import { useMemo } from "react";
import type { CopyOverrides } from "@fiket/booth-schema";
import { resolveCopy } from "@fiket/booth-schema";
import { useBoothConfig } from "../store/booth";
import { useRouter } from "../store/router";
import { buildStrings } from "./strings";

const NO_OVERRIDES: CopyOverrides = {};

/**
 * 현재 언어의 문구. 기본 딕셔너리 → 브랜딩 텍스트(ko/en) → 부스 문구 오버라이드(콘솔 "문구 편집") 순으로 합친다.
 * config 로딩 전에는 기본 문구로 렌더하고 로드되면 재계산한다.
 */
export function useI18n() {
  const language = useRouter((s) => s.language);
  const copy = useBoothConfig((s) => s.config?.copy ?? NO_OVERRIDES);
  const branding = useBoothConfig((s) => s.config?.branding ?? null);
  const t = useMemo(() => buildStrings(resolveCopy(language, copy, branding)), [language, copy, branding]);
  return { t, language };
}
